import React from "react";
import AccountSetting from "@components/User/Account/AccountSetting";

export default function Account() {
  return <AccountSetting />;
}
